import { render } from "./facial_biometrics_component.html?vue&type=template&id=97aff3e6&external"
import script from "./facial_biometrics_component.js?vue&type=script&lang=js&external"
export * from "./facial_biometrics_component.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__